import { isEmpty, isEqual, isNil, isString } from 'lodash';
import { TodoItem, TodoItemStatus } from '@shared/components/blocks/types';
import { EditableField, Field } from './Field';

export class TodoField implements EditableField {
  readonly fieldType = 'TodoField';
  readonly todos: TodoItem[];

  constructor(todos: TodoItem[]) {
    this.todos = todos;
  }

  validate(): string | null {
    return null;
  }

  isEqual(field: Field): boolean {
    return field instanceof TodoField && isEqual(this.todos, field.todos);
  }

  toFieldJson() {
    return this.todos;
  }

  get isEmpty() {
    return isEmpty(this.todos);
  }

  static fromFieldJson(jsonBlob: MBAPI.Scalar.JSON): TodoField | null {
    if (Array.isArray(jsonBlob) && jsonBlob.every(isTodoItem)) {
      return new TodoField(jsonBlob);
    } else {
      return null;
    }
  }
}

function isTodoItem(item: any): item is TodoItem {
  return (
    !isNil(item) && isString(item.id) && isString(item.summary) && isTodoItemStatus(item.status)
  );
}

function isTodoItemStatus(status: string): status is TodoItemStatus {
  return status === 'NEEDS-ACTION' || status === 'COMPLETED';
}
